<template>
  <div class="pagination-loader">
    <div 
      class="pagination-loader__spinner"
      :aria-label="ariaLabel"
      role="status"
    ></div>
    <span v-if="showText" class="pagination-loader__text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'PaginationLoader',
  props: {
    text: {
      type: String,
      default: 'Loading more...'
    },
    showText: {
      type: Boolean,
      default: true
    },
    ariaLabel: {
      type: String,
      default: 'Loading more content'
    }
  }
}
</script>

<style scoped>
.pagination-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  margin: 16px 0;
}

.pagination-loader__spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4ecdc4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.pagination-loader__text {
  font-size: 14px;
  color: #888;
  font-weight: 400;
  user-select: none;
}

@keyframes spin {
  from { 
    transform: rotate(0deg); 
  }
  to { 
    transform: rotate(360deg); 
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .pagination-loader__spinner {
    animation: none;
    border-top-color: rgba(255, 255, 255, 0.3);
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .pagination-loader__spinner {
    border-color: #ffffff;
    border-top-color: #4ecdc4;
  }
  
  .pagination-loader__text {
    color: #ffffff;
  }
}
</style>